"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gdLogo = _interopRequireDefault(require("@ux/gd-logo"));
var _plLogo = _interopRequireDefault(require("@ux/pl-logo"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * Renders shared GD or reseller logo.
 *
 * @param {Object} props Properties
 * @returns {React.ReactElement} shared logo
 * @public
 */
function Logo(props) {
  var _window$ux;
  /** @type {?Object} */
  // eslint-disable-next-line no-undefined
  var uxData = typeof window === 'undefined' ? undefined : (_window$ux = window.ux) === null || _window$ux === void 0 ? void 0 : _window$ux.data;
  var defaultProps = _objectSpread({
    collapsedLogo: false,
    // Do not use `ux.data.countryName` since this should be empty except for when we use this in the headers and are in
    // specific markets
    country: '',
    market: (uxData === null || uxData === void 0 ? void 0 : uxData.market) || 'en-US',
    privateLabelId: (uxData === null || uxData === void 0 ? void 0 : uxData.privateLabelId) || 1,
    privateLabelName: uxData === null || uxData === void 0 ? void 0 : uxData.privateLabelName,
    logos: uxData === null || uxData === void 0 ? void 0 : uxData.logos,
    showCountryNameOnLogo: false,
    urlArgs: {}
  }, props);
  return defaultProps.privateLabelId === 1 ? /*#__PURE__*/_react["default"].createElement(_gdLogo["default"], defaultProps) : /*#__PURE__*/_react["default"].createElement(_plLogo["default"], defaultProps);
}
Logo.propTypes = {
  /** CSS class name to apply to the outer element */
  'className': _propTypes["default"].string,
  /** use the mobile logo at all breakpoints */
  'collapsedLogo': _propTypes["default"].bool,
  /** Current country name. */
  'country': _propTypes["default"].string,
  /** Unique id used for Traffic 2 ie: 'your.product.godaddy.preformatted.eid_value.click' */
  'data-eid': _propTypes["default"].string,
  /** href to pass to Link component */
  'href': _propTypes["default"].string,
  /** An object with desktop and mobile reseller logo source links */
  'logos': _propTypes["default"].shape({
    desktop: _propTypes["default"].string,
    mobile: _propTypes["default"].string
  }),
  /** GoDaddy Airo only: Logo variant selector */
  'logoVariant': _propTypes["default"].oneOf(['fullColor', 'monochrome']),
  /** Current market */
  'market': _propTypes["default"].string,
  /** Callback for a click on the logo link */
  'onClick': _propTypes["default"].func,
  /** The private label ID */
  'privateLabelId': _propTypes["default"].number,
  /** The reseller's private label name shown under the logo image or when no logos provided */
  'privateLabelName': _propTypes["default"].string,
  /** if true, and not US market, country label on logo will be generated */
  'showCountryNameOnLogo': _propTypes["default"].bool,
  /** CSS class name to apply to outer `figure` element */
  'figClass': _propTypes["default"].string,
  /** An object with specifications for a temporary alternate logo */
  'tempLogo': _propTypes["default"].shape({
    filename: _propTypes["default"].string,
    start: _propTypes["default"].object,
    end: _propTypes["default"].object,
    styles: _propTypes["default"].object,
    altText: _propTypes["default"].string
  }),
  /** An object with arguments being passed to `Link` component to generate correct `href` */
  'urlArgs': _propTypes["default"].object,
  /** An object with urls from rootProps including the CDN url for a temporary logo */
  'urls': _propTypes["default"].shape({
    cdn: _propTypes["default"].shape({
      href: _propTypes["default"].string
    })
  })
};
var _default = Logo;
exports["default"] = _default;